import React from 'react';
import LocationTemplate from './LocationTemplate';

const SevenSpringsPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Seven Springs"
      stateName="North Carolina"
      countyName="Wayne"
      zipCodes={["28578"]}
      latitude={35.2168}
      longitude={-77.7747}
      population={110}
      historicalFact="Named after seven natural springs in the area; incorporated in 1923."
      nearbyTowns={[
        "Goldsboro, NC",
        "Mount Olive, NC",
        "La Grange, NC",
        "Pikeville, NC",
        "Fremont, NC",
        "Dudley, NC",
        "Kinston, NC",
        "Eureka, NC"
      ]}
    />
  );
};

export default SevenSpringsPage;